import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'appDomains',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  editURL: '',
  emptyMessage: "You don't have any dns configured, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'dns',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The dns for the app',
      label: 'DNS',
      canFilter: true,
      canEdit: true,
      canCreate: true,
      exactWidth:'30%'
    },
    {
      attributeName: 'configApiUrl',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The config api associated to the dns',
      label: 'Config Api Url',
      canFilter: true,
      canEdit: true,
      canCreate: true,
    },
  ],
};
